import { render, staticRenderFns } from "./ArchivedPlans.vue?vue&type=template&id=9f4eb8cc&"
import script from "./ArchivedPlans.vue?vue&type=script&lang=js&"
export * from "./ArchivedPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports